const list_mixin = {
  data() {
    return {
      n_key: '', //实体第几列
      matching_results: [], //实体匹配结果
    }
  },
  computed: {
    entity_keys() {
      return this.$store.state.entity_keys
    }
  },
  methods: {
      dealList(arr_content)  { // 处理榜单数据
        let col_list = []
        let arr = []
        let n_key = ''
        if(arr_content){
          let content = JSON.parse(arr_content)
          let content_c = content.splice(1, content.length)
          //组装对象数组 表格数据
          content_c.forEach((item, index) => {
            arr[index]  = {...item}
          })
          //组装表头
          content[0].forEach((item, index) =>{
            //列的类型 type
            let type = 0
            if(this.entity_keys.includes(item)){
              type = 3 //实体
              this.n_key = index 
              n_key = index
            }else{
              type = 0 //普通类型
            }

            //组装表头
            col_list.push({
              name: item,
              type: type,
              n_key: n_key
            })
          })
        }
        return {
          col_list: col_list,
          arr: arr,
          n_key: n_key
        }
      },
      dealListEntity(arr_content)  { // 处理榜单数据 实体
        let arr = []
        let e_index = ''
        if(arr_content){
          let content = JSON.parse(arr_content)
          let content_c = content.splice(1, content.length)
          //组装对象数组 表格数据
          content_c.forEach((item, index) => {
            arr[index]  = {...item}
          })
          content[0].forEach((i, i_index) =>{
            if(this.entity_keys.includes(i)){
              e_index = i_index
            }
          })
        }
        return {
          arr: arr.map(a => a[e_index]),
          n_key: this.key 
        }
      },
      //处理实体 跳转
      getResult(row, type_c) {
        let temp = this.matching_results.find(item => item.short_name == row[this.n_key])
        if(type_c == '1'){ //动脉橙
          if(temp && temp.uid){
            let route = temp.type == '0' ? 'companyDetail' : temp.type == '1' ? 'orgDetail' : 'hospitalDetail'
            return route + '/' + temp.uid
          }else{
            return ''
          }
        }else if(type_c == '2'){ //官网
          return temp && temp.main_page ? temp.main_page : ''
        }
      }
  }
}

const scroll_mixin = {
methods: {
    //锚点监听
    listenerScroll(item, size = 0) {
      let top = document.documentElement.scrollTop || document.body.scrollTop  //滚动条的值
      let offset = $('.list-table').offset().top
      let footer = $('.footer').offset().top
      if(top >= offset - 80 ){
        $('.anchor').addClass('anchor-fixed')
        let bottom = top + window.innerHeight - footer + size
        if (bottom > - 1) {
            $('.' + item).css('bottom', (bottom + 20) + 'px')
        } else {
            $('.' + item).css('bottom', (size + 20) + 'px')
        }
      }else{
        $('.anchor').removeClass('anchor-fixed')
        $('.' + item).css('bottom', 0 + 'px')
      }
    }
}
}

export { list_mixin, scroll_mixin }
